import React from 'react';
import MobilePersonalUpgradeWrapper from '../../commerce/mobile_personal_upgrade/wrapper';
import flashMessage from '../../flash_message/helpers/get_flash_message';

const UpgradeToContact = (props) => {
  if (props.paymentProviders.length) {
    return (
      <React.Fragment>
        <MobilePersonalUpgradeWrapper
          staticData={props.staticData}
          products={props.products}
          paymentProviders={props.paymentProviders}
          discounts={props.discounts}
          checkoutCart={props.checkoutCart}
          context={props.context}
          stripeUrls={props.stripeUrls}
          message={props.message}
          experiments={props.experiments}
          winterSale={props.winterSale}
          paymentSuccessCallback={props.paymentCallback}
          beforeSubmitErrorCheck={props.beforeSubmitErrorCheck}
          localisations={props.localisations}
          walletButtons={props.walletButtons}
        />
      </React.Fragment>
    );
  }
  return flashMessage.showErrorMessage(
    'Sorry, our payment providers are currently unavailable. Please try again later.',
  );
};

export default UpgradeToContact;
